import React from "react";
import styled from "styled-components";
import { useRouter } from "next/router";
import { useTranslation } from "@pancakeswap/localization";
import { NextLinkFromReactRouter } from "../../../components/NextLink";
import { NotificationDot } from "../../../components/NotificationDot";
import { ButtonMenu, ButtonMenuItem } from "../../../components/ButtonMenu";

const Wrapper = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    padding-left: 12px;
    padding-right: 12px;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    margin-left: 16px;
  }
`;

interface FarmTabButtonsProps {
   children?: import('react').ReactNode; hasStakeInFinishedFarms: boolean;
}

export const FarmTabButtons: React.FC<React.PropsWithChildren<FarmTabButtonsProps>> = ({ hasStakeInFinishedFarms }) => {
  const router = useRouter();
  const { t } = useTranslation();

  let activeIndex;
  switch (router.pathname) {
    case "/farms":
      activeIndex = 0;
      break;
    case "/farms/history":
      activeIndex = 1;
      break;
    case "/_mp/farms/history":
      activeIndex = 1;
      break;
    case "/farms/archived":
      activeIndex = 2;
      break;
    default:
      activeIndex = 0;
      break;
  }

  if (!hasStakeInFinishedFarms) {
    return <></>
  }

  return (
    <Wrapper>
      <ButtonMenu activeIndex={activeIndex} scale="sm" variant="subtle">
        <ButtonMenuItem as={NextLinkFromReactRouter} to="/farms">
          {t("Live")}
        </ButtonMenuItem>
        <NotificationDot show={hasStakeInFinishedFarms}>
          <ButtonMenuItem as={NextLinkFromReactRouter} to="/farms/history" id="finished-farms-button">
            {t("Finished")}
          </ButtonMenuItem>
        </NotificationDot>
      </ButtonMenu>
    </Wrapper>
  );
};
